module.exports = "<footer>\n  <div>\n    Copyright © {{currentYear}}. SASADoctor-HLTR. All Rights Reserved\n  </div>\n  <div class=\"clearfix\"></div>\n</footer>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/footer/footer.component.html
// module id = ./src/app/shared/footer/footer.component.html
// module chunks = main